'use client'

import type { ReactNode } from 'react'
import { Buttons } from '../../buttons/index.ts'

export const FieldModalButtons = ({ children }: { children: ReactNode }) => {
  return (
    <footer className="p-8 w-full flex-initial">
      <Buttons className="w-full flex flex-col gap-2">{children}</Buttons>
    </footer>
  )
}
